import { Component, Inject, OnInit } from '@angular/core';
import { UtilitiesService } from '@app/shared/services/utilities.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss'],
})
export class DynamicDialogComponent implements OnInit {
  submitCssClass = 'bg-success';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private matDialogRef: MatDialogRef<DynamicDialogComponent>) {}

  ngOnInit() {}

  submit() {
    this.data.service.dialogAction(this.data.action, this.data);
    this.matDialogRef.close(this.data.data);
  }
}
